export default __webpack_public_path__ + "static/media/BosaImportants3.de9c91ce.JPG";